import React from "react";
import LegalLayout, { Section } from "../components/LegalLayout";
import { usePageTitle } from "../lib/usePageTitle";

export default function Terms() {
  usePageTitle("Terms of Use");
  return (
    <LegalLayout eyebrow="The fine print, kept simple" title="Terms of Use" updated="February 2026">
      <Section heading="Acceptance">
        <p>
          By using this website you agree to these terms. The site is operated by
          <strong> Alpha Media and Automations LLC</strong>, trading as <strong>Get Virtual Growth</strong>.
          Founded and led by <strong>Krishna S.</strong> from Dubai, with time spent working across Spain
          and the wider European region.
        </p>
      </Section>
      <Section heading="The free diagnosis is complimentary">
        <p>
          Our business diagnosis and any recommendations we share before an engagement are offered free of charge,
          with no obligation. Requesting a diagnosis does not create a contract or commit you to anything.
        </p>
      </Section>
      <Section heading="Services are provided under a separate agreement">
        <p>
          Any paid services begin only under a separate written agreement between us. That agreement sets out the
          scope, terms and fees. You are always free to choose the services you want, and either side may pause or
          end the engagement as set out in that agreement.
        </p>
      </Section>
      <Section heading="Honest expectations">
        <p>
          We are committed to your growth, but we do not promise specific sales or revenue figures. What we promise
          is honest diagnosis, dedicated work, and outcomes we pursue together. Your customers' satisfaction always
          remains your own responsibility.
        </p>
      </Section>
      <Section heading="Confidentiality (both ways)">
        <p>
          We keep your business information confidential, and we will not disclose that you are our client while our
          engagement is active. In return, any methods, tools or materials we share with you remain our confidential
          property and trade secrets, and may not be shared without our permission.
        </p>
      </Section>
      <Section heading="Intellectual property">
        <p>
          All content on this website, including text, design and illustrations, belongs to us and may not be copied
          or reused without written permission.
        </p>
      </Section>
      <Section heading="Limitation of liability">
        <p>
          This website and its content are provided "as is" for information. To the fullest extent permitted by law,
          we are not liable for any indirect or consequential loss arising from use of the site.
        </p>
      </Section>
      <Section heading="Governing law">
        <p>
          These terms are governed by the laws of the Emirate of Dubai and the applicable federal laws of the
          United Arab Emirates. Where the founder is temporarily based in Spain or elsewhere in Europe, the
          operating entity remains the Dubai-registered <strong>Alpha Media and Automations LLC</strong>.
        </p>
      </Section>
      <Section heading="Contact">
        <p>
          Questions? Reach us at
          <a className="text-brass hover:underline" href="mailto:hello@GetVirtualGrowth.com"> hello@GetVirtualGrowth.com</a>.
          Every message reaches Krishna S. directly.
        </p>
      </Section>
    </LegalLayout>
  );
}
